import { cn } from '@/lib/utils';
import { InfoCardLayout, InfoCardProps } from './types';

const contentClassNames: Record<InfoCardLayout, string> = {
  center: 'flex w-full flex-col items-center gap-2',
  row: 'flex min-w-0 flex-1 items-start gap-2'
};

const descriptionClassNames: Record<InfoCardLayout, string> = {
  center: 'w-full text-sm leading-5',
  row: 'min-w-0 flex-1 text-xs leading-4'
};

const layoutClassNames: Record<InfoCardLayout, string> = {
  center: 'flex-col items-center justify-center p-4 text-center',
  row: 'items-start gap-2 px-4 py-3 text-left'
};

const titleClassNames: Record<InfoCardLayout, string> = {
  center: 'text-base leading-6 text-foreground',
  row: 'text-sm leading-5 text-foreground'
};

const InfoCard = (props: InfoCardProps) => {
  const {
    action,
    className,
    description,
    descriptionClassName,
    icon,
    layout = 'center',
    minHeightClassName = layout === 'center' ? 'min-h-[124px]' : '',
    title,
    titleClassName
  } = props;

  const shouldRenderContent = Boolean(icon || title || description);

  return (
    <article
      className={cn(
        'flex w-full font-sans rounded-2xl border border-border-strong bg-surface',
        layoutClassNames[layout],
        action && layout === 'center' ? 'gap-6' : 'gap-2',
        minHeightClassName,
        className
      )}
    >
      {shouldRenderContent ? (
        <div className={contentClassNames[layout]}>
          {icon ? <span className="shrink-0">{icon}</span> : null}
          {title ? (
            <p className={cn(titleClassNames[layout], titleClassName)}>
              {title}
            </p>
          ) : null}
          {description ? (
            <p
              className={cn(
                descriptionClassNames[layout],
                'text-muted-foreground',
                descriptionClassName
              )}
            >
              {description}
            </p>
          ) : null}
        </div>
      ) : null}
      {action ? <div className="w-full">{action}</div> : null}
    </article>
  );
};

export default InfoCard;